var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3659 26.8295L7.07317 22.1953L0 25.6099V35.366L6.34146 38.7807V31.9514L15.3659 26.8295Z",
    fill: "#F8A76E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2193 22.4388L19.7559 27.3169L27.8047 22.9267V13.6584L19.7559 9.26812V18.2925L11.2193 22.4388Z",
    fill: "#F7A76E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8044 40.2438V22.9268L9.51172 32.9268V49.9999L27.8044 40.2438Z",
    fill: "#EB1E24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.6098V9.02439L16.8293 0L17.0732 17.3171L0 25.6098Z",
    fill: "#EB1E24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.75dd0bc8037c7381a724977e9e6a6cb7.svg";
export { ForwardRef as ReactComponent };